import { render, staticRenderFns } from "./AlarmDescModal.vue?vue&type=template&id=6d9634aa&"
import script from "./AlarmDescModal.js?vue&type=script&lang=js&"
export * from "./AlarmDescModal.js?vue&type=script&lang=js&"
import style0 from "./AlarmDescModal.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports